import { env } from '@shared/config/env'

const PARTNERS_HOST_BY_ENV = {
  local: 'dev-podo-partners-gcp.re-speak.com',
  development: 'dev-podo-partners-gcp.re-speak.com',
  staging: 'stage-partners.podospeaking.com',
  temp: 'temp-podo-partners-gcp.re-speak.com',
  qa: 'dev-podo-partners-gcp.re-speak.com',
  production: 'podo-partners-gcp.re-speak.com',
} as const satisfies Record<(typeof env)['APP_ENV'], string>

export const getPartnersHost = (appEnv: (typeof env)['APP_ENV'] = env.APP_ENV) => {
  return PARTNERS_HOST_BY_ENV[appEnv]
}

export const getPartnersUrl = (appEnv: (typeof env)['APP_ENV'] = env.APP_ENV) => {
  return `https://${getPartnersHost(appEnv)}`
}
